var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"header-content"},[_c('Head')],1),_c('div',{staticClass:"nav"},[_c('main-nav')],1),_c('div',{staticClass:"contentBox"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }